import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';
import { AppSettingService } from '../app.service';

import { UserInfoService } from '../user/user-info.service';

@Injectable({
	providedIn: 'root'
})
export class CareerOneStopAPIService {
	constructor(
		private userInfo: UserInfoService,
		private http: HttpClient
	) { }

	private url = AppSettingService.appConfig.JourneyAPIUrl + "CareerOneStop";

	getOccupationVideo(onetCode: string): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + '/Occupation/Video/' + encodeURIComponent(onetCode),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	getProfessionalAssociations(onetCode: string, limit: number, offset: number): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + '/Occupation/Associations/' + encodeURIComponent(onetCode) + '?limit=' + encodeURIComponent(limit) + '&offset=' + encodeURIComponent(offset), 
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}
}
